module.exports = __webpack_public_path__ + "static/media/OverheadSquatfemale-cropped.f2ebfd1e.svg";